
        var result = require("!!../../../../node_modules/css-loader/index.js!./marketing-info.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/marketing/marketing-info/marketing-info.component.css
// module id = 2522
// module chunks = 1